export default "__VITE_ASSET__DH7F$kFU__"